import React, { useContext } from 'react';
/* eslint-disable import/no-extraneous-dependencies */
import CardMedia from '@mui/material/CardMedia';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';
import CompanyRootElement from './style';
import { SuccessStoriesContextConsumer } from '../../../common/context/success-stories/context';
import { SuccessStoriesStateInterface } from '../../../common/context/success-stories/interface';
import StoriesSection from '../../../common/storiesSection';
import { ENVIRONMENT, ENVIRONMENT_CONSTANTS } from '../../../common/constants';
import { getFeatureSuccessStories } from '../../../utils/profile.util';
import EnvContext from '../../../common/envContext';

const CompanyInformation = ({
  successStories = SuccessStoriesStateInterface.successStories, loading,
  partnerDetail = SuccessStoriesStateInterface.partnerDetail,
}) => {
  const { t } = useTranslation();
  const envVars = useContext(EnvContext);
  const { [ENVIRONMENT]: env } = envVars || {};

  const getFeaturedImage = () => {
    if (successStories?.featured_image_large) {
      return `${ENVIRONMENT_CONSTANTS[env].PARTNER_HOST}${successStories?.featured_image_large}`;
    }
    if (partnerDetail?.success_stories?.length) {
      const allFeaturedStories = getFeatureSuccessStories(partnerDetail?.success_stories);
      const currentSuccessStory = allFeaturedStories.filter((story) => story.id === successStories.id)[0];
      if (currentSuccessStory?.logo_url) {
        return currentSuccessStory?.logo_url;
      }
    }
    return '/support/partners/images/partner-profile/story-image-1.png';
  };

  return (
    <CompanyRootElement>
      <Box className="story-section-top">
        <Box className="story-page-container">
          <Typography mb={2} variant="eyebrow" data-testid="Success Story">
            {t('Success Story')}
          </Typography>
          <Typography variant="headline-larger" maxWidth="800px" component="h1">
            {!loading && `${t(successStories?.title) || ''}`}
            {(loading) && <Skeleton animation="pulse" variant="text" />}
          </Typography>
          <Box className="default-card-image">
            {(!loading) && (
              <CardMedia
                alt={successStories?.title}
                component="img"
                width="100%"
                image={getFeaturedImage()}
              />
            )}
            {(loading) && (
              <Skeleton
                variant="rectangular"
                width="100%"
                height="575px"
              />
            )}
          </Box>
        </Box>
      </Box>
      <StoriesSection
        title="Customer challenge"
        content={successStories?.customer_challenge || ''}
        loading={loading}
      />
      <StoriesSection
        title="Project goals"
        content={successStories?.project_goals || ''}
        loading={loading}
      />
      <StoriesSection
        title="Solution"
        content={successStories?.solutions || ''}
        loading={loading}
      />
      <StoriesSection
        title="Business outcome"
        content={successStories?.business_outcomes || ''}
        loading={loading}
      />

      <StoriesSection
        title="Conclusion"
        content={successStories?.conclusion || ''}
        loading={loading}
      />
    </CompanyRootElement>
  );
};
CompanyInformation.propTypes = {
  successStories: PropTypes.shape({}),
  loading: PropTypes.bool,
  partnerDetail: PropTypes.shape({}),
};
CompanyInformation.defaultProps = {
  successStories: {},
  loading: false,
  partnerDetail: {},
};
export default SuccessStoriesContextConsumer(CompanyInformation);
